import {
    getCurrentProductCode,
    isPluginProduct,
} from '@common/api/productContext';

export type AdminProductFeatures = {
    workspaceRecord: boolean;
    workspaceSkills: boolean;
    auditLog: boolean;
    billingAndPlans: boolean;
    usage: boolean;
    pricingModal: boolean;
    desktopDownload: boolean;
    pluginInstall: boolean;
    memberInvites: boolean;
    rolesAndPermissions: boolean;
    workspaceOwnershipTransfer: boolean;
    brandManagement: boolean;
    marketIntelligence: boolean;
};

const BUSTLY_ADMIN_FEATURES: AdminProductFeatures = {
    workspaceRecord: true,
    workspaceSkills: true,
    auditLog: true,
    billingAndPlans: true,
    usage: true,
    pricingModal: true,
    desktopDownload: true,
    pluginInstall: false,
    memberInvites: true,
    rolesAndPermissions: true,
    workspaceOwnershipTransfer: true,
    brandManagement: true,
    marketIntelligence: true,
};

const PLUGIN_ADMIN_FEATURES: AdminProductFeatures = {
    workspaceRecord: false,
    workspaceSkills: false,
    auditLog: true,
    billingAndPlans: true,
    usage: false,
    pricingModal: true,
    desktopDownload: false,
    pluginInstall: true,
    memberInvites: true,
    rolesAndPermissions: true,
    workspaceOwnershipTransfer: true,
    brandManagement: false,
    marketIntelligence: false,
};

export const getAdminProductFeatures = (
    productCode = getCurrentProductCode(),
): AdminProductFeatures =>
    isPluginProduct(productCode)
        ? PLUGIN_ADMIN_FEATURES
        : BUSTLY_ADMIN_FEATURES;

const SETTINGS_TAB_FEATURES = {
    'workspace-skills': 'workspaceSkills',
    'value-ledger': 'workspaceRecord',
    'audit-log': 'auditLog',
    billing: 'billingAndPlans',
    usage: 'usage',
    brands: 'brandManagement',
} as const satisfies Partial<Record<string, keyof AdminProductFeatures>>;

export const isAdminSettingsTabAvailable = (
    tab: string,
    productCode = getCurrentProductCode(),
): boolean => {
    const feature =
        SETTINGS_TAB_FEATURES[tab as keyof typeof SETTINGS_TAB_FEATURES];
    return feature ? getAdminProductFeatures(productCode)[feature] : true;
};
